var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.75C21.1 29.75 22 28.85 22 27.75H18C18 28.85 18.9 29.75 20 29.75ZM26 23.75V18.75C26 15.68 24.37 13.11 21.5 12.43V11.75C21.5 10.92 20.83 10.25 20 10.25C19.17 10.25 18.5 10.92 18.5 11.75V12.43C15.64 13.11 14 15.67 14 18.75V23.75L12 25.75V26.75H28V25.75L26 23.75ZM24 24.75H16V18.75C16 16.27 17.51 14.25 20 14.25C22.49 14.25 24 16.27 24 18.75V24.75ZM15.58 11.83L14.15 10.4C11.75 12.23 10.17 15.05 10.03 18.25H12.03C12.18 15.6 13.54 13.28 15.58 11.83ZM27.97 18.25H29.97C29.82 15.05 28.24 12.23 25.85 10.4L24.43 11.83C26.45 13.28 27.82 15.6 27.97 18.25Z",
    fill: "#4C5C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.9d8b404be4b76cf6c976b3d8b2c48505.svg";
export { ForwardRef as ReactComponent };